export default "__VITE_ASSET__CPZwHkU3__"